// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const apiform = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: async (username, password) => {
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);
    const response = await apiform.post("/auth/login", formData);
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
    }
    return response.data;
  },
  logout: () => {
    localStorage.removeItem("token");
  },
  getCurrentUser: async () => {
    const response = await api.get("/auth/me");
    return response.data;
  },
};

export const userService = {
  getUsers: async (page = 0, limit = 10) => {
    /*const response = await api.get(
      `/sys/users?skip=${page * limit}&limit=${limit}`
    );*/
    const response = await api.get("/sys/users");
    return response.data;
  },
  createUser: async (userData) => {
    const response = await api.post("/sys/users", userData);
    return response.data;
  },
  updateUser: async (id, userData) => {
    userData["id"] = id;
    userData["is_active"] = true;
    const response = await api.put(`/sys/users/${id}`, userData);
    return response.data;
  },
  deleteUser: async (id) => {
    const response = await api.delete(`/sys/users/${id}`);
    return response.data;
  },
  toggleUserStatus: async (id, isActive) => {
    const response = await api.put(`/sys/users/status/${id}`, null, {
      params: {
        is_active: isActive,
      },
    });
    return response.data;
  },
  updateUserPassword: async (id, password) => {
    // 更新用戶密碼
    const response = await api.put(`/sys/users/password/${id}`, null, {
      params: {
        password: password,
      },
    });
    return response.data;
  },
};

export const botService = {
  getBots: async () => {
    const response = await api.get("/bots/bots");
    return response.data;
  },
  createBot: async (botData) => {
    const response = await api.post("/bots/bots", botData);
    return response.data;
  },
  updateBot: async (id, botData) => {
    const response = await api.put(`/bots/bots/${id}`, botData);
    return response.data;
  },
  deleteBot: async (id) => {
    const response = await api.delete(`/bots/bots/${id}`);
    return response.data;
  },

  // 添加新方法
  getLineUsers: async (callid) => {
    const response = await api.get(`/bots/lineusers?callid=${callid}`);
    return response.data;
  },

  getTelegramChats: async (callid) => {
    const response = await api.get(`/bots/tgchats?callid=${callid}`);
    return response.data;
  },

  updateTelegramChatStatus: async (chatId, callid, isEnabled) => {
    const response = await api.put(`/bots/tgchats/${chatId}/status`, null, {
      params: {
        callid: callid,
        is_enabled: isEnabled,
      },
    });
    return response.data;
  },

  updateLineUserStatus: async (userId, callid, isEnabled) => {
    const response = await api.put(`/bots/lineusers/${userId}/status`, null, {
      params: {
        callid: callid,
        is_enabled: isEnabled,
      },
    });
    return response.data;
  },

  setTelegramWebhook: async (callid, url) => {
    const response = await api.post("/bots/telegram/set_webhook", null, {
      params: {
        callid: callid,
        url: url,
      },
    });
    return response.data;
  },
};

export const ruleService = {
  // 獲取所有機器人轉發規則
  getRules: async () => {
    const response = await api.get("/bots/get_bot_rules");
    return response.data;
  },

  // 設置機器人轉發規則
  setRule: async (recvCallid, type, relayCallid) => {
    const response = await api.post("/bots/set_bot_rule", null, {
      params: {
        recv_callid: recvCallid,
        type: type,
        relay_callid: relayCallid,
      },
    });
    return response.data;
  },

  // 新增清空規則方法
  clearRules: async (recvCallid) => {
    const response = await api.post("/bots/clr_bot_rule", null, {
      params: {
        recv_callid: recvCallid,
      },
    });
    return response.data;
  },
};

export default api;
